const payments = {
  paymentsGetProductsRequest: ['couponCode', 'testMode'],
  paymentsGetProductsSuccess: ['products'],
  paymentsGetProductsFailure: ['error'],
}

export default payments
